<div class="logout-header" mat-dialog-title>
  <h2>Sign out</h2>
  <button
    aria-label="Close sign out dialog"
    class="close-button"
    type="button"
    [disabled]="isSubmitting"
    (click)="dialogRef.close()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<mat-dialog-content class="logout-content">
  <p class="logout-question">Keep cached platform data on this device for faster sign-in next time?</p>
  <p class="logout-note">This does not retain your authentication session.</p>
</mat-dialog-content>

<mat-dialog-actions class="logout-actions">
  <div class="logout-choices">
    <button mat-stroked-button color="warn" type="button" [disabled]="isSubmitting" (click)="signOut(true)">
      {{
        submittingChoice === 'clear'
          ? 'Signing out...'
          : 'Sign out and clear local data'
      }}
    </button>
    <button mat-raised-button color="primary" type="button" [disabled]="isSubmitting" (click)="signOut(false)">
      {{
        submittingChoice === 'keep'
          ? 'Signing out...'
          : 'Sign out and keep platform data'
      }}
    </button>
  </div>
</mat-dialog-actions>
